import { BaseModel } from '..';
import { Flight } from '../flights';
import { Person } from '../people';

const initialState: TripsState = {
  ephemeralTrip: {},
  tripsMap: new Map(),
  lastFetched: 0,
  data: [],
  newTrip: null,
  source: null,
};

export enum TripsActionTypes {
  DELETE_TRIP = 'trips/deleteTrip',
  SAVE_ALL = 'trips/saveAll',
  SAVE_EPHEMERAL_ENTRY = 'trips/saveEphemeralEntry',
  SAVE = 'trips/save',
  SAVE_SOURCE = 'trips/saveSource',
  UPDATE = 'trips/update',
}

interface DeleteTripTripsActionType {
  type: TripsActionTypes.DELETE_TRIP;
  payload: Trip;
}

interface SaveAllTripsActionType {
  type: TripsActionTypes.SAVE_ALL;
  payload: Trip[];
}

interface SaveEphemeralEntryTripsActionType {
  type: TripsActionTypes.SAVE_EPHEMERAL_ENTRY;
  payload: Trip;
}

interface SaveTripsActionType {
  type: TripsActionTypes.SAVE;
  payload: Trip;
}

interface UpdateTripsActionType {
  type: TripsActionTypes.UPDATE;
  payload: Trip;
}

interface SaveSourceTripsActionType {
  type: TripsActionTypes.SAVE_SOURCE;
  payload: TripsState;
}

type TripsAction =
  | DeleteTripTripsActionType
  | SaveAllTripsActionType
  | SaveEphemeralEntryTripsActionType
  | SaveTripsActionType
  | SaveSourceTripsActionType
  | UpdateTripsActionType;

export default function(state = initialState, action: TripsAction): TripsState {
  switch (action.type) {
    case TripsActionTypes.SAVE_ALL: {
      const tripsMap = new Map(state.tripsMap.entries());
      if (action.payload && Array.isArray(action.payload)) {
        action.payload.forEach((trip) => {
          tripsMap.set(trip.id, {
            // ...tripsMap.get(trip.id),
            ...trip,
            lastFetched: Date.now(),
          });
        });
      }
      return {
        ...state,
        tripsMap,
        lastFetched: Date.now(),
        data: action.payload,
      };
    }
    case TripsActionTypes.UPDATE: {
      const tripsMap = new Map(state.tripsMap.entries());
      if (action.payload && action.payload.id) {
        tripsMap.set(action.payload.id, {
          // ...tripsMap.get(action.payload.id),
          ...action.payload,
          lastFetched: Date.now(),
        });
      }
      return {
        ...state,
        tripsMap,
        lastFetched: Date.now(),
        newTrip: null,
      };
    }
    case TripsActionTypes.SAVE: {
      const tripsMap = new Map(state.tripsMap.entries());
      if (action.payload && action.payload.id) {
        tripsMap.set(action.payload.id, {
          ...tripsMap.get(action.payload.id),
          ...action.payload,
          lastFetched: Date.now(),
        });
      }
      return {
        ...state,
        tripsMap,
        lastFetched: Date.now(),
        newTrip: action.payload,
      };
    }
    case TripsActionTypes.SAVE_EPHEMERAL_ENTRY: {
      return {
        ...state,
        ephemeralTrip: {
          ...state.ephemeralTrip,
          ...action.payload,
        },
      };
    }
    case TripsActionTypes.SAVE_SOURCE: {
      return {
        ...state,
        source: action.payload.source,
      };
    }
    case TripsActionTypes.DELETE_TRIP: {
      const tripsMap = new Map(state.tripsMap.entries());
      if (action.payload && action.payload.id) {
        tripsMap.delete(action.payload.id);
      }
      return {
        ...state,
        tripsMap,
        newTrip: null,
      };
    }
    default:
      return state;
  }
}

export interface TripsState {
  tripsMap: Map<string, Trip>;
  ephemeralTrip: Trip | {};
  lastFetched: number;
  data: Trip[];
  newTrip: Trip;
  source: string;
}

export interface Trip extends BaseModel {
  first_officer_id: string;
  captain_id: string;
  id: string;
  aircraft_id: string;
  number: number;
  callsign: string;
  landings: number;
  start_airport: string;
  end_airport: string;
  date: string;
  aircraft_registration?: string;
  captain?: Person;
  first_officer?: Person;
  flights?: Flight[];
  attachments?: [];
  status?: string;
  trip_category?: string;
  duty_logs?: DutyLog[];
  custom_data?: any;
  srp_number?: number;
  signature_url?: any;
  signature_image_url?: any;
  completion_signature_url?: any;
  completion_signature_image_url?: any;
  validation_justification?: string;
}

export interface DutyLog {
  created_at: string;
  deleted_at: string;
  end_carried_forward: boolean;
  end_time: string;
  id: string;
  person_id: string;
  position: string;
  split_off: string;
  split_on: string;
  start_carried_forward: boolean;
  start_time: string;
  trip_id: string;
  updated_at: string;
}
